export default __webpack_public_path__ + "static/media/events.bf8ee226.svg";